import { useQuery } from '@tanstack/react-query';

import { BANK_BULK_IMPORTS_KEY } from 'hooks/keys';
import { useUser } from 'hooks/queries';
import { BanksApi } from '../../../api';

export function useBankBulkImports() {
  const banksApi = new BanksApi();
  const { userBankId } = useUser();

  const { data: bulkImports, isLoading: isLoadingBulkImports } = useQuery({
    enabled: !!userBankId.length,
    queryKey: [BANK_BULK_IMPORTS_KEY, userBankId],
    queryFn: () => banksApi.getBulkImports(userBankId)
  });

  return { bulkImports, isLoadingBulkImports };
}
